export const ethereumMethods = {
  REQUEST_ACCOUNTS: "eth_requestAccounts",
};

export const TOKEN_NAMES = {
  FET: "FET",
  AGIX: "AGIX",
};
